import yup from 'src/libraries/validator.library';

export const FlightPilotSchema = yup
  .object({
    pilotId: yup.number().required(),
    name: yup.string().required(),
    phone: yup.string().nullable(),
  })
  .defined();

export const FlightTailNumberSchema = yup
  .object({
    tailNumber: yup.string(),
    tailId: yup.number().required(),
  })
  .defined();

export const FlightOperatorShape = {
  operatorId: yup.number().required(),
  name: yup.string().required(),
  email: yup.string().nullable(),
  activeFlag: yup.boolean(),
  dispatchFlag: yup.boolean(),
  Pilots: yup.array().of(FlightPilotSchema.clone()),
  TailNumbers: yup.array().of(FlightTailNumberSchema.clone()),
};

export const FlightOperatorSchema = yup
  .object()
  .shape({
    ...FlightOperatorShape,
  })
  .defined();

export const FlightOperatorListSchema = yup
  .object({
    operators: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...FlightOperatorShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const FlightOperatorFormSchema = yup
  .object({
    name: yup.string().required(),
    email: yup.string().email().required(),
    activeFlag: yup.boolean(),
    dispatchFlag: yup.boolean(),
    operatorId: yup.number(),
  })
  .defined();

export const FlightOperatorResponsePayloadSchema = yup
  .object({
    operators: yup
      .object({
        operatorId: yup.number(),
        name: yup.string(),
        email: yup.string(),
        activeFlag: yup.boolean(),
        dispatchFlag: yup.boolean(),
      })
      .defined(),
  })
  .defined();

export type IFlightOperator = yup.InferType<typeof FlightOperatorSchema>;
export type IFlightOperatorList = yup.InferType<
  typeof FlightOperatorListSchema
>;
export type IFlightOperatorForm = yup.InferType<
  typeof FlightOperatorFormSchema
>;
export type IFlightPilot = yup.InferType<typeof FlightPilotSchema>;
export type IFlightTailNumber = yup.InferType<typeof FlightTailNumberSchema>;
